'use client'
import { HeaderTag } from '@/components/HeaderTag'
import { SliderNavigation } from '@/components/SliderNavigation'
import moduleStyles from '@/modules/AboutPage/AboutPage.module.scss'
import { Member } from '@/services/Api/generated'
import cn from 'classnames'
import { FunctionComponent } from 'react'
import 'swiper/css'
import 'swiper/css/free-mode'
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Employee } from '../Employee'
import styles from './Teams.module.scss'

type TeamProps = {
  className?: string
  members: Member[]
  withoutHeaderTag?: boolean
}
export const Team: FunctionComponent<TeamProps> = ({
  className,
  members,
  withoutHeaderTag = false,
}) => {
  return (
    <div className={cn(className, styles.container)}>
      {!withoutHeaderTag ? (
        <div className={styles.headerTag}>
          <HeaderTag icon="briefcase" title="Управленческий состав" />
        </div>
      ) : null}
      <h2 className={moduleStyles.title}>Наша команда</h2>
      <Swiper
        className={styles.list}
        spaceBetween={12}
        wrapperClass={styles.swiperWrapper}
        slidesPerView={'auto'}
        modules={[FreeMode]}
        freeMode={true}
        breakpoints={{
          768: {
            enabled: false,
            spaceBetween: 0,
          },
        }}
      >
        {members.map((member) => (
          <SwiperSlide key={member.name} className={styles.employee}>
            <Employee
              photo={
                // eslint-disable-next-line @next/next/no-img-element
                <img
                  src={member.image?.[0]?.url}
                  alt=""
                  className={styles.photo}
                />
              }
              name={member.name}
              post={member.position}
            />
          </SwiperSlide>
        ))}
        <SliderNavigation className={styles.navigation} />
      </Swiper>
    </div>
  )
}
